import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { UserWithProfile } from "@/pages/Users";
import type { UserRole } from "./types";
import type { UserFormData } from "./types";

interface UserFormProps {
  user: UserWithProfile;
  formData: UserFormData;
  isLoading: boolean;
  onFieldChange: (field: string, value: string) => void;
}

export function UserForm({ user, formData, isLoading, onFieldChange }: UserFormProps) {
  return (
    <div className="grid gap-4 py-4">
      <div className="grid gap-2">
        <Label htmlFor="firstName">Prénom</Label>
        <Input
          id="firstName"
          value={formData.firstName}
          onChange={(e) => onFieldChange("firstName", e.target.value)}
          disabled={isLoading}
        />
      </div>
      
      <div className="grid gap-2">
        <Label htmlFor="lastName">Nom</Label>
        <Input
          id="lastName"
          value={formData.lastName}
          onChange={(e) => onFieldChange("lastName", e.target.value)}
          disabled={isLoading}
        />
      </div>
      
      <div className="grid gap-2">
        <Label htmlFor="email">Email</Label>
        <Input
          id="email"
          type="email"
          value={formData.email}
          onChange={(e) => onFieldChange("email", e.target.value)}
          disabled={isLoading}
        />
      </div>

      <div className="grid gap-2">
        <Label>Rôle</Label>
        <Select
          value={formData.role}
          onValueChange={(value: UserRole) => onFieldChange("role", value)}
          disabled={isLoading}
        >
          <SelectTrigger>
            <SelectValue placeholder="Sélectionnez un rôle" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="user">Utilisateur</SelectItem>
            <SelectItem value="admin">Administrateur</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}